import React from 'react'
import Contentimage from './Contentimage'
import Chaptersection from './Chaptersection'

export default function
  () {
  return (
    <>
      <Contentimage />
      <Chaptersection />
    </>
  )
}
